module.exports = __webpack_public_path__ + "static/img/storywalk-sign-and-frame.4f12418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/story-walk/storywalk-sign-and-frame.jpg
// module id = 702
// module chunks = 0